export default __webpack_public_path__ + "static/media/hostfully_step7.5ac02f6b.png";